import { Rectangle, Marker } from "react-leaflet";
import L from "leaflet";

const gardenIcon = new L.Icon({
  iconUrl:
    "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-green.png",
  shadowUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});

function roundCoord(value) {
  return Number(Number(value).toFixed(6));
}

function disableMapDrag(e) {
  e?.target?._map?.dragging?.disable();
}

function enableMapDrag(e) {
  e?.target?._map?.dragging?.enable();
}

function buildRectangleGeometry(bounds) {
  const nw = bounds[0];
  const se = bounds[1];

  return {
    type: "rectangle",
    coordinates: [
      [nw[0], nw[1]],
      [nw[0], se[1]],
      [se[0], se[1]],
      [se[0], nw[1]],
    ],
  };
}

export default function RectangleGardenLayer({
  rectBounds,
  rectDragRef,
  pendingRectRef,
  setRectBounds,
  commitRectBounds,
}) {
  const nw = rectBounds[0];
  const se = rectBounds[1];
  const ne = [nw[0], se[1]];
  const sw = [se[0], nw[1]];

  return (
    <>
      <Rectangle
        bounds={rectBounds}
        pathOptions={{
          color: "#24582A",
          weight: 3,
          fillOpacity: 0.18,
        }}
        interactive
        eventHandlers={{
          mousedown: (e) => {
            if (!e?.latlng) return;

            rectDragRef.current.active = true;
            rectDragRef.current.last = e.latlng;
            pendingRectRef.current = rectBounds;

            disableMapDrag(e);
          },

          mouseover: (e) =>
            e.target.setStyle({
              weight: 5,
              fillOpacity: 0.22,
            }),

          mouseout: (e) =>
            e.target.setStyle({
              weight: 3,
              fillOpacity: 0.18,
            }),
        }}
      />

      {[nw, ne, sw, se].map((corner, i) => (
        <Marker
          key={i}
          position={corner}
          icon={gardenIcon}
          draggable
          eventHandlers={{
            dragstart: (e) => {
              rectDragRef.current.active = true;
              pendingRectRef.current = rectBounds;

              disableMapDrag(e);
            },

            drag: (e) => {
              const pos = e.target.getLatLng();

              let newNW = [...nw];
              let newSE = [...se];

              if (i === 0) {
                newNW = [
                  roundCoord(pos.lat),
                  roundCoord(pos.lng),
                ];
              }

              if (i === 1) {
                newNW = [
                  roundCoord(pos.lat),
                  newNW[1],
                ];

                newSE = [
                  newSE[0],
                  roundCoord(pos.lng),
                ];
              }

              if (i === 2) {
                newNW = [
                  newNW[0],
                  roundCoord(pos.lng),
                ];

                newSE = [
                  roundCoord(pos.lat),
                  newSE[1],
                ];
              }

              if (i === 3) {
                newSE = [
                  roundCoord(pos.lat),
                  roundCoord(pos.lng),
                ];
              }

              const nextBounds = [
                newNW,
                newSE,
              ];

              pendingRectRef.current =
                nextBounds;

              setRectBounds(nextBounds);
            },

            dragend: (e) => {
              rectDragRef.current.active = false;
              rectDragRef.current.last = null;

              enableMapDrag(e);

              if (pendingRectRef.current) {
                const geometry =
                  buildRectangleGeometry(
                    pendingRectRef.current,
                  );

                commitRectBounds(
                  pendingRectRef.current,
                  geometry,
                );

                pendingRectRef.current =
                  null;
              }
            },
          }}
        />
      ))}
    </>
  );
}